<div class="modal-header">
  <h4 class="modal-title">Upload Document{{programName ? ' for ' + programName : ''}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="!hasSelectedFile">
    <ngx-file-drop (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)"
      [accept]="fileTypes" [multiple]="multiple" dropZoneClassName="Unused">
      <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
        <div [style]="{'border-color': dragIsIn ? 'red' : '#0782d0'}" class="FileSelectDropZone">
          <div style="height: 100px;"></div>
          <p [style]="{'color': dragIsIn ? 'red' : ''}">Drop {{fileTypesInstructionFragment}} to upload</p>
          <p [style]="{'color': dragIsIn ? 'red' : ''}">or</p>
          <button type="button" (click)="openFileSelector()">Browse for {{fileTypesInstructionFragment}} files</button>
        </div>
      </ng-template>
    </ngx-file-drop>
  </div>

  <div *ngIf="hasSelectedFile" class="text-center p-4">
    <div class="alert alert-success d-flex align-items-center">
      <i class="fas fa-check-circle mr-2"></i>
      <div>
        <strong>File Selected:</strong> {{selectedFileName}}
        <br>
        <small class="text-muted">{{selectedFileSize}}</small>
      </div>
      <button type="button" class="btn btn-sm btn-outline-secondary ml-auto" (click)="clearSelectedFile()">
        Change File
      </button>
    </div>
  </div>
</div>
<div class="modal-footer d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center">
    <div *ngIf="showSubcategoryDropdown" class="d-flex align-items-center mr-3">
      <label class="mr-2 mb-0">Doc Type:</label>
      <div ngbDropdown class="d-inline-block mr-2">
        <button class="btn btn-outline-secondary btn-sm" id="modalSubcategoryDropdown" ngbDropdownToggle>
          {{getDisplaySubcategory() || 'Select Type'}}
        </button>
        <div ngbDropdownMenu aria-labelledby="modalSubcategoryDropdown">
          <button ngbDropdownItem (click)="selectSubcategory('Identification')">Identification</button>
          <button ngbDropdownItem (click)="selectSubcategory('Insurance Card')">Insurance Card</button>
          <button ngbDropdownItem (click)="selectSubcategory('Medical Records')">Medical Records</button>
          <button ngbDropdownItem (click)="selectSubcategory('Other')">Other</button>
        </div>
      </div>
      <div *ngIf="selectedSubcategory === 'Other'" class="d-flex align-items-center">
        <input type="text"
               class="form-control form-control-sm"
               placeholder="Specify document type..."
               [(ngModel)]="customSubcategory"
               (input)="onCustomSubcategoryChange()"
               style="width: 200px;">
      </div>
    </div>
    <span *ngIf="errorMessage" style="color: red;">{{errorMessage}}</span>
  </div>
  <div class="d-flex">
    <button type="button" class="btn btn-outline-dark mr-2" (click)="modal.dismiss()">Close</button>
    <button type="button" class="btn btn-primary" [disabled]="!canSubmit" (click)="submit()">Submit</button>
  </div>
</div>
